// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   Cotify Toast — light glassmorphism, top-right, slide-in
   ═══════════════════════════════════════════════════════════════ */

[data-sonner-toaster][data-y-position="top"] {
  top: 1.5rem !important;
}

[data-sonner-toaster][data-x-position="right"] {
  right: 1.5rem !important;
  left: auto !important;
  width: min(380px, calc(100vw - 1.75rem)) !important;
}

[data-sonner-toast].cotify-toast-host,
[data-sonner-toast][data-styled="true"] {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  /* Evita el slide horizontal default de Sonner (quedaba en diagonal) */
  transform: none !important;
  transition: opacity 280ms ease, transform 280ms ease !important;
}

[data-sonner-toast][data-removed="true"].cotify-toast-host {
  opacity: 0 !important;
  transform: translateY(-10px) !important;
}

.cotify-toast {
  --t-accent: #fa7317;
  --t-icon-bg: rgba(250, 115, 23, 0.14);
  --t-duration: 4.2s;

  position: relative;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  column-gap: 0.9rem;
  width: 100%;
  padding: 1rem 0.95rem 1.15rem 1rem;
  border-radius: 18px;
  color: #0f172a;
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(250, 115, 23, 0.14) 0%, transparent 48%),
    linear-gradient(
      155deg,
      rgba(255, 255, 255, 0.78) 0%,
      rgba(255, 251, 247, 0.62) 55%,
      rgba(255, 255, 255, 0.55) 100%
    );
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow:
    0 0 0 1px rgba(15, 23, 42, 0.04),
    0 10px 28px rgba(15, 23, 42, 0.08),
    0 24px 48px rgba(250, 115, 23, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(18px) saturate(1.35);
  -webkit-backdrop-filter: blur(18px) saturate(1.35);
  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  overflow: hidden;
  isolation: isolate;
  animation: cotify-toast-enter 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.cotify-toast__glow {
  position: absolute;
  top: -42%;
  right: -18%;
  width: 170px;
  height: 170px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(250, 115, 23, 0.18) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

.cotify-toast__icon,
.cotify-toast__content,
.cotify-toast__dismiss {
  position: relative;
  z-index: 1;
}

.cotify-toast__icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 1px solid rgba(250, 115, 23, 0.18);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.7),
    0 4px 12px rgba(250, 115, 23, 0.12);
}

.cotify-toast__icon .pi {
  font-size: 0.9rem;
  font-weight: 700;
}

.cotify-toast__content {
  min-width: 0;
  padding-top: 0.1rem;
  padding-right: 0.15rem;
}

.cotify-toast__chip {
  display: inline-block;
  margin: 0 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  opacity: 0.95;
}

.cotify-toast__text {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 500;
  line-height: 1.45;
  color: #1e293b;
  letter-spacing: -0.015em;
}

.cotify-toast__dismiss {
  width: 1.7rem;
  height: 1.7rem;
  margin-top: 0.05rem;
  border: none;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.04);
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.cotify-toast__dismiss .pi {
  font-size: 0.6rem;
}

.cotify-toast__dismiss:hover {
  background: rgba(250, 115, 23, 0.12);
  color: #fa7317;
  transform: scale(1.05);
}

.cotify-toast__timer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  z-index: 2;
  background: linear-gradient(
    90deg,
    var(--t-accent) 0%,
    rgba(251, 146, 60, 0.75) 55%,
    transparent 100%
  );
  transform-origin: left center;
  animation: cotify-toast-timer var(--t-duration) linear forwards;
  opacity: 0.95;
}

.cotify-toast--success {
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(52, 211, 153, 0.16) 0%, transparent 48%),
    linear-gradient(
      155deg,
      rgba(255, 255, 255, 0.78) 0%,
      rgba(240, 253, 244, 0.58) 55%,
      rgba(255, 255, 255, 0.55) 100%
    );
  box-shadow:
    0 0 0 1px rgba(15, 23, 42, 0.04),
    0 10px 28px rgba(15, 23, 42, 0.08),
    0 24px 48px rgba(16, 185, 129, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

.cotify-toast--error {
  background:
    radial-gradient(120% 140% at 0% 0%, rgba(251, 113, 133, 0.14) 0%, transparent 48%),
    linear-gradient(
      155deg,
      rgba(255, 255, 255, 0.78) 0%,
      rgba(255, 241, 242, 0.58) 55%,
      rgba(255, 255, 255, 0.55) 100%
    );
  box-shadow:
    0 0 0 1px rgba(15, 23, 42, 0.04),
    0 10px 28px rgba(15, 23, 42, 0.08),
    0 24px 48px rgba(244, 63, 94, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

@keyframes cotify-toast-enter {
  0% {
    opacity: 0;
    transform: translateY(-18px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Salida: misma dirección (sube hacia arriba) */
[data-sonner-toast][data-removed="true"] .cotify-toast {
  animation: cotify-toast-exit 280ms cubic-bezier(0.4, 0, 1, 1) forwards;
}

@keyframes cotify-toast-exit {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-14px);
  }
}

@keyframes cotify-toast-timer {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}

@media (max-width: 480px) {
  [data-sonner-toaster][data-x-position="right"] {
    right: 0.75rem !important;
    left: 0.75rem !important;
    width: auto !important;
  }

  .cotify-toast {
    border-radius: 16px;
    padding: 0.9rem 0.85rem 1.05rem;
  }

  .cotify-toast__text {
    font-size: 0.88rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AppToaster.css"],"names":[],"mappings":"AAAA;;oEAEoE;;AAEpE;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;;EAEE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,sEAAsE;EACtE,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;;EAElB,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd;;;;;;;KAOG;EACH,2CAA2C;EAC3C;;;;2CAIyC;EACzC,0CAA0C;EAC1C,kDAAkD;EAClD,4EAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iFAAiF;EACjF,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0CAA0C;EAC1C;;uCAEqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yEAAyE;AAC3E;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;EACV;;;;;GAKC;EACD,6BAA6B;EAC7B,+DAA+D;EAC/D,aAAa;AACf;;AAEA;EACE;;;;;;;KAOG;EACH;;;;2CAIyC;AAC3C;;AAEA;EACE;;;;;;;KAOG;EACH;;;;2CAIyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gDAAgD;AAChD;EACE,sEAAsE;AACxE;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   Cotify Toast — light glassmorphism, top-right, slide-in\n   ═══════════════════════════════════════════════════════════════ */\n\n[data-sonner-toaster][data-y-position=\"top\"] {\n  top: 1.5rem !important;\n}\n\n[data-sonner-toaster][data-x-position=\"right\"] {\n  right: 1.5rem !important;\n  left: auto !important;\n  width: min(380px, calc(100vw - 1.75rem)) !important;\n}\n\n[data-sonner-toast].cotify-toast-host,\n[data-sonner-toast][data-styled=\"true\"] {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  width: 100% !important;\n  /* Evita el slide horizontal default de Sonner (quedaba en diagonal) */\n  transform: none !important;\n  transition: opacity 280ms ease, transform 280ms ease !important;\n}\n\n[data-sonner-toast][data-removed=\"true\"].cotify-toast-host {\n  opacity: 0 !important;\n  transform: translateY(-10px) !important;\n}\n\n.cotify-toast {\n  --t-accent: #fa7317;\n  --t-icon-bg: rgba(250, 115, 23, 0.14);\n  --t-duration: 4.2s;\n\n  position: relative;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: start;\n  column-gap: 0.9rem;\n  width: 100%;\n  padding: 1rem 0.95rem 1.15rem 1rem;\n  border-radius: 18px;\n  color: #0f172a;\n  background:\n    radial-gradient(120% 140% at 0% 0%, rgba(250, 115, 23, 0.14) 0%, transparent 48%),\n    linear-gradient(\n      155deg,\n      rgba(255, 255, 255, 0.78) 0%,\n      rgba(255, 251, 247, 0.62) 55%,\n      rgba(255, 255, 255, 0.55) 100%\n    );\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  box-shadow:\n    0 0 0 1px rgba(15, 23, 42, 0.04),\n    0 10px 28px rgba(15, 23, 42, 0.08),\n    0 24px 48px rgba(250, 115, 23, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(18px) saturate(1.35);\n  -webkit-backdrop-filter: blur(18px) saturate(1.35);\n  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif;\n  overflow: hidden;\n  isolation: isolate;\n  animation: cotify-toast-enter 360ms cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.cotify-toast__glow {\n  position: absolute;\n  top: -42%;\n  right: -18%;\n  width: 170px;\n  height: 170px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(250, 115, 23, 0.18) 0%, transparent 70%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.cotify-toast__icon,\n.cotify-toast__content,\n.cotify-toast__dismiss {\n  position: relative;\n  z-index: 1;\n}\n\n.cotify-toast__icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 1px solid rgba(250, 115, 23, 0.18);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.7),\n    0 4px 12px rgba(250, 115, 23, 0.12);\n}\n\n.cotify-toast__icon .pi {\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.cotify-toast__content {\n  min-width: 0;\n  padding-top: 0.1rem;\n  padding-right: 0.15rem;\n}\n\n.cotify-toast__chip {\n  display: inline-block;\n  margin: 0 0 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  opacity: 0.95;\n}\n\n.cotify-toast__text {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 500;\n  line-height: 1.45;\n  color: #1e293b;\n  letter-spacing: -0.015em;\n}\n\n.cotify-toast__dismiss {\n  width: 1.7rem;\n  height: 1.7rem;\n  margin-top: 0.05rem;\n  border: none;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.04);\n  color: #94a3b8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;\n}\n\n.cotify-toast__dismiss .pi {\n  font-size: 0.6rem;\n}\n\n.cotify-toast__dismiss:hover {\n  background: rgba(250, 115, 23, 0.12);\n  color: #fa7317;\n  transform: scale(1.05);\n}\n\n.cotify-toast__timer {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  z-index: 2;\n  background: linear-gradient(\n    90deg,\n    var(--t-accent) 0%,\n    rgba(251, 146, 60, 0.75) 55%,\n    transparent 100%\n  );\n  transform-origin: left center;\n  animation: cotify-toast-timer var(--t-duration) linear forwards;\n  opacity: 0.95;\n}\n\n.cotify-toast--success {\n  background:\n    radial-gradient(120% 140% at 0% 0%, rgba(52, 211, 153, 0.16) 0%, transparent 48%),\n    linear-gradient(\n      155deg,\n      rgba(255, 255, 255, 0.78) 0%,\n      rgba(240, 253, 244, 0.58) 55%,\n      rgba(255, 255, 255, 0.55) 100%\n    );\n  box-shadow:\n    0 0 0 1px rgba(15, 23, 42, 0.04),\n    0 10px 28px rgba(15, 23, 42, 0.08),\n    0 24px 48px rgba(16, 185, 129, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.85);\n}\n\n.cotify-toast--error {\n  background:\n    radial-gradient(120% 140% at 0% 0%, rgba(251, 113, 133, 0.14) 0%, transparent 48%),\n    linear-gradient(\n      155deg,\n      rgba(255, 255, 255, 0.78) 0%,\n      rgba(255, 241, 242, 0.58) 55%,\n      rgba(255, 255, 255, 0.55) 100%\n    );\n  box-shadow:\n    0 0 0 1px rgba(15, 23, 42, 0.04),\n    0 10px 28px rgba(15, 23, 42, 0.08),\n    0 24px 48px rgba(244, 63, 94, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.85);\n}\n\n@keyframes cotify-toast-enter {\n  0% {\n    opacity: 0;\n    transform: translateY(-18px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Salida: misma dirección (sube hacia arriba) */\n[data-sonner-toast][data-removed=\"true\"] .cotify-toast {\n  animation: cotify-toast-exit 280ms cubic-bezier(0.4, 0, 1, 1) forwards;\n}\n\n@keyframes cotify-toast-exit {\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-14px);\n  }\n}\n\n@keyframes cotify-toast-timer {\n  from {\n    transform: scaleX(1);\n  }\n  to {\n    transform: scaleX(0);\n  }\n}\n\n@media (max-width: 480px) {\n  [data-sonner-toaster][data-x-position=\"right\"] {\n    right: 0.75rem !important;\n    left: 0.75rem !important;\n    width: auto !important;\n  }\n\n  .cotify-toast {\n    border-radius: 16px;\n    padding: 0.9rem 0.85rem 1.05rem;\n  }\n\n  .cotify-toast__text {\n    font-size: 0.88rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
